"use strict";
var lib_core = require("lib-core");

var AbstractToolController = require("./../../../extensions/abstractToolController.js");
var TriangleToolStateMachine = require("./triangleToolStateMachine.js");

var TriangleToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        flip: 1,
        fill: false,
        strokeWidth: 2
    });

    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(TriangleToolController, AbstractToolController);
TriangleToolController.inject = AbstractToolController.inject;
TriangleToolController.StateMachineClass = TriangleToolStateMachine;

module.exports = TriangleToolController;

TriangleToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Triangle',
        title: 'Triangle',
        style: {
            icon: 'icon-triangle.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
